import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import AtalLogo from "../../assets/images/atal.png";
import NvidiaLogo from "../../assets/images/nvidia.png";
import IncubationLogo from "../../assets/images/incubation.png";

const IncubationPartners = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  const incubationData = {
    title: "Incubated By",
    logos: [
      {
        src: AtalLogo,
        alt: "Atal Incubation Center",
        name: "Atal Incubation Center",
      }
    ],
  };

  const partnersData = {
    title: "Part of",
    logos: [
      {
        src: NvidiaLogo,
        alt: "NVIDIA Inception Program",
        name: "NVIDIA Inception Program",
      },
    ],
  };

  return (
    <div className="w-full h-full flex box-border p-8 py-16 bg-gradient-to-br from-gray-50 to-blue-50/20 rounded-3xl my-12">
      <div className="w-full h-full flex flex-col items-center justify-center">
        {/* Section Header */}
        <div className="w-full text-center mb-12">
          <h2
            className="text-3xl md:text-5xl mt-5 text-center font-mazzardbold bg-clip-text text-transparent bg-gradient-to-r from-black to-blue-900"
            data-aos="fade-up"
          >
            Our Ecosystem
          </h2>
          <p
            className="text-gray-600 mt-4 max-w-2xl mx-auto"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Proudly supported by leading organizations and innovation programs
          </p>
        </div>

        <div className="w-full flex flex-col lg:flex-row gap-16 items-center justify-center max-w-6xl">
          {/* Incubated By Section */}
          <div
            className="flex flex-col items-center justify-center w-full lg:w-1/2"
            data-aos="fade-right"
            data-aos-delay="300"
          >
            <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8 text-center">
              {incubationData.title}
            </h3>
            <div className="flex flex-wrap gap-8 items-center justify-center">
              {incubationData.logos.map((logo, index) => (
                <div
                  key={index}
                  className="group flex flex-col items-center justify-center"
                  data-aos="zoom-in"
                  data-aos-delay={400 + index * 200}
                >
                  <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform group-hover:-translate-y-2 group-hover:scale-105">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-20 w-auto object-contain transition-all duration-300 group-hover:scale-110"
                    />
                  </div>
                  <p className="text-sm text-gray-600 mt-3 text-center font-medium max-w-[120px]">
                    {logo.name}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="hidden lg:block w-px h-32 bg-gradient-to-b from-transparent via-gray-300 to-transparent"></div>
          <div className="lg:hidden w-32 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>

          {/* Partners Section */}
          <div
            className="flex flex-col items-center justify-center w-full lg:w-1/2"
            data-aos="fade-left"
            data-aos-delay="300"
          >
            <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8 text-center">
              {partnersData.title}
            </h3>
            <div className="flex flex-wrap gap-8 items-center justify-center">
              {partnersData.logos.map((logo, index) => (
                <div
                  key={index}
                  className="group flex flex-col items-center justify-center"
                  data-aos="zoom-in"
                  data-aos-delay={600 + index * 200}
                >
                  <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform group-hover:-translate-y-2 group-hover:scale-105">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="h-20 w-auto object-contain transition-all duration-300 group-hover:scale-110"
                    />
                  </div>
                  <p className="text-sm text-gray-600 mt-3 text-center font-medium max-w-[120px]">
                    {logo.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncubationPartners;
